import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Card, CardContent } from "@mui/material";
import FolderList from "../../features/folderList/FolderList";
import { useResourceSync } from "../../hooks/useResourceSync";

export default function FolderLayout() {
    const location = useLocation();
    const isListDetails = location.pathname.includes("listDetails");

    // Keep the file-explorer grid in sync when a folder/file is deleted in any
    // other browser session (the deleting user's or another user's). See useResourceSync.
    useResourceSync();

    return (
        <>
            {/* Render Home content only if not in ListDetails */}
            {!isListDetails && <Outlet />}

            {/* FolderList stays mounted always */}
            <section className="mb-3" id="all-files">
                <Card>
                    <CardContent>
                        <FolderList />
                    </CardContent>
                </Card>
            </section>
        </>
    );
}
